import store from '@/config/vuex'
import { isEmpty as isEmptyArray } from '@/helpers/array'

export default {
  getSortedCards(cardsFiltered, currentSorting) {
    let cf = JSON.parse(JSON.stringify(cardsFiltered))
    this.resetDisplayedVariant(cf)
    if (currentSorting === 'highprice') cf = cf.sort((card1, card2) => card2.price - card1.price)
    else if (currentSorting === 'lowprice') cf = cf.sort((card, card2) => card.price - card2.price)
    else if (currentSorting === 'bestseller')
      cf = this.setMaxSale(cf).sort((c1, c2) => c2.maxSale - c1.maxSale)

    return cf
  },

  getPromoCardsMatchingFilters(cards) {
    const state = store.state.filter
    const filters = { ...state.itemFilters.selected, ...state.variantFilters.selected }
    let matchingCards = cards

    matchingCards.forEach(card => {
      card.mandatoryFilterValues = card.mandatoryFilterValues || {}
      card.mandatoryFiltersNotMatched = JSON.parse(JSON.stringify(card.mandatoryFilterValues))
      card.priorityLevel = 0
    })
    for (const filterKey in filters) {
      filters[filterKey].forEach(filterValue => {
        if (!filterValue) return

        matchingCards = matchingCards.filter(card => {
          // MANDATORY FILTERS:
          // All the mandatory filters must be matched for the card to be displayed. That's why the
          // following method will only check if it matches the filter without filtering them out
          // yet (needs to complete the loop on `filters` to really know if they all matched or not)
          this.checkMandatoryFilterMatches(card, filterKey, filterValue)

          // NORMAL FILTERS:
          // Keep only the cards that either don't have the filter or have the filter with the
          // correct filter value (i.e. if "product: shoes" filter is applied, it will filter out
          // cards with "product: apparel" but keep the cards without a "product" filter)
          const hasFilter = !isEmptyArray(card.filterValues[filterKey])
          const hasFilterMatching = hasFilter && card.filterValues[filterKey].includes(filterValue)

          return !hasFilter || hasFilterMatching
        })
      })
    }
    matchingCards = matchingCards.filter(card => {
      // Filter out the cards that still have mandatory filters that have not been matched.
      return Object.values(card.mandatoryFiltersNotMatched).every(notMatched => !notMatched.length)
    })
    // The priority level is increased each time a mandatory filter is matched which makes the cards
    // matching all their mandatory filters showing up first
    return matchingCards.sort((a, b) => b.priorityLevel - a.priorityLevel)
  },

  getCardsWithoutEmptyVariants(cardsFiltered) {
    const cardsWithoutEmptyVariants = JSON.parse(JSON.stringify(cardsFiltered))
    return cardsWithoutEmptyVariants.filter(card => card.variants.length)
  },

  getCardsWithPromoCards(payload) {
    const cards = JSON.parse(JSON.stringify(payload.cards))
    const promoCards = this.getPromoCardsMatchingFilters(payload.promoCards)

    payload.currentBreakpoint.promoPositions.forEach((position, index) => {
      // Always show at least one promo card if one exists
      if (promoCards[index] && (index === 0 || position <= cards.length)) {
        cards.splice(position, 0, promoCards[index])
      }
    })
    return cards
  },

  getCardsWithProductGroupPromoCards(payload) {
    const cardsFilteredWithPromos = JSON.parse(JSON.stringify(payload.cards))
    const isPrimaryFilterActive = payload.activePrimaryFilters.some(f => Object.values(f)[0] !== '')
    const isSecondaryFilterActive = payload.tags.length > 0

    // If filter or sorting is applied, don't insert any promocards
    if (payload.currentSorting !== 'featured' || isPrimaryFilterActive || isSecondaryFilterActive)
      return cardsFilteredWithPromos

    this.getPromoCardsMatchingFilters(payload.promoCards).forEach(promoCard => {
      if (promoCard.productGroup === null) return
      let promoCardIndex = cardsFilteredWithPromos.findIndex(
        card => card.productGroup === promoCard.productGroup
      )
      if (promoCardIndex > -1) cardsFilteredWithPromos.splice(promoCardIndex, 0, promoCard)
    })
    return cardsFilteredWithPromos
  },
}
